import { render, staticRenderFns } from "./BindPhysicalCpu.vue?vue&type=template&id=1adc2355&"
import script from "./BindPhysicalCpu.vue?vue&type=script&lang=js&"
export * from "./BindPhysicalCpu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports